import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { translations } from '../../../search-library/src/i18n/index';

Vue.use(VueI18n);

export default new VueI18n({
  locale: 'de_DE', // set locale
  fallbackLocale: 'en_GB', // set fallback locale
  messages: translations, // set locale messages
});
